import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import AlertService from '../Services/AlertService';
import {extractErrorMessage} from '../Services/RequestService';

export const useAlerts = (vehicleId) => {
    const [alerts, setAlerts] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            const resp = vehicleId ? await AlertService.allVehicleAlerts(vehicleId, token) : await AlertService.allAlerts(token);
            setAlerts(resp.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addAlert = async (alert, storedVehicleId) => {
        try {
            await AlertService.addAlert(alert, storedVehicleId ? storedVehicleId : vehicleId, token);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateAlert = async (alert, alertId) => {
        try {
            await AlertService.updateAlert(alert, alertId, token);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteAlert = async (alertId) => {
        try {
            await AlertService.deleteAlert(alertId, token);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [alerts, addAlert, updateAlert, deleteAlert];
}


// WEBPACK FOOTER //
// ./src/Hooks/useAlerts.js